// extracted by mini-css-extract-plugin
export var image = "index-module--image--djLhO";
export var button = "index-module--button--a6+0K";